import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0606699c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style1 from "./index.vue?vue&type=style&index=1&id=0606699c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0606699c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/thScoreShop/thScoreAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0606699c')) {
      api.createRecord('0606699c', component.options)
    } else {
      api.reload('0606699c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0606699c&scoped=true&", function () {
      api.rerender('0606699c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/rw/tempDetail/index.vue"
export default component.exports